import * as React from "react";

import { FocusGroupContext } from "azure-devops-ui/FocusGroup";
import { FocusZoneContext } from "azure-devops-ui/FocusZone";
import { Tooltip } from "azure-devops-ui/TooltipEx";
import { css } from "azure-devops-ui/Util";

interface INavigationItemProps {
    id: string;
    className?: string;
    name: string;
    url: string;
    isSelected: boolean;
    isExpanded: boolean;
    children?: JSX.Element[];
    onClick?: (selectedTabId: string) => void;
}

export class NavigationItem extends React.Component<INavigationItemProps> {
    public render() {
        const { isSelected, isExpanded, id, url, children, className, name } = this.props;
        return (
            <FocusGroupContext.Consumer>
                {focusGroupContext => (
                    <FocusZoneContext.Consumer>
                        {cellContext => (
                            <li>
                                <a
                                    aria-expanded={children ? isExpanded : undefined}
                                    className={css(className, "nav-item-container", isSelected || isExpanded ? "selected" : "")}
                                    data-focuszone={cellContext.focuszoneId}
                                    href={url}
                                    id={id}
                                    key={url}
                                    onClick={this.onClick}
                                    onFocus={focusGroupContext.onFocus.bind(this, id)}
                                    tabIndex={focusGroupContext.focusedElementId === id ? 0 : -1}
                                >
                                    <span className="nav-item flex-row flex-center">
                                        <Tooltip text={url} disabled={false} fixedLayout={false} overflowOnly={true}>
                                            <span className="nav-item-text focus-treatment">{name}</span>
                                        </Tooltip>
                                    </span>
                                </a>
                                {isExpanded && children ? <ul className="nav-item-children">{isExpanded && children}</ul> : null}
                            </li>
                        )}
                    </FocusZoneContext.Consumer>
                )}
            </FocusGroupContext.Consumer>
        );
    }

    private onClick = (event: React.MouseEvent<HTMLElement>) => {
        const { url, onClick } = this.props;

        let updatePivot = true;

        // If ctrl-click is pressed, and there is a URL specified for this item, then
        // don't handle the click here, allowing the browser to perform a navigation
        // (i.e. open in a new tab/window)
        if (event.ctrlKey) {
            if (url) {
                updatePivot = false;
            }
        }

        if (onClick && updatePivot) {
            event.preventDefault();
            onClick(url);
        }
    };
}
